import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme/theme.scss';
import './theme/master.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
